import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { NodeActionsComponent } from 'src/app/shared/components/node-actions/node-actions.component';
import { HitModel } from '../../models/hit.model';
import { ViewTreeNode } from '../../models/view.tree-node';
import { SetContextMenu } from '../../state/engine.actions';

@Component({
  selector: 'app-engine-contextmenu',
  templateUrl: './engine-contextmenu.component.html',
  styleUrls: ['./engine-contextmenu.component.scss']
})
export class EngineContextmenuComponent implements OnInit, AfterViewInit {

  @ViewChild(NodeActionsComponent, { static: true })
  nodeActionsComponent: NodeActionsComponent;

  @Input()
  node: ViewTreeNode;

  @Input()
  hit: HitModel;

  constructor(
    private store: Store
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.nodeActionsComponent.nodeActionsTrigger.openMenu();
  }

  onNodeActionsClosed() {
    this.store.dispatch(new SetContextMenu(null, null));
  }

  getNodeActionsStyles() {
    return {
      'left.px': this.hit ? this.hit.canvasPos[0] : 0,
      'top.px': this.hit ? this.hit.canvasPos[1] : 0,
    };
  }

}
